const CheckConditionValue = (
  keyNameValue: any,
  valueWanted: any,
  default_value: any
): boolean => {
  return (
    valueWanted.includes(keyNameValue) ||
    (valueWanted.includes(default_value) && keyNameValue === undefined)
  );
};

export default CheckConditionValue;
